import { NgModule } from '@angular/core';
import { CoreModule } from '../core/core.module';
import { CommonModule } from '../common/common.module';
import { MortgageRoutingModule } from './mortgage-routing.module';
import { CompanyMortgageService } from './service/company-mortgage.service';
import { CreditInstituteService } from './service/credit-institute.service';
import { CompanyMortgageFormComponent } from './component/company-mortgage-form/company-mortgage-form.component';
import { CreditInstituteFormComponent } from './component/credit-institute-form/credit-institute-form.component';
import { MortgageGuard } from './service/guard/mortgage-guard.service';
import { CompanyMortgageManagerComponent } from './component/company-mortgage-manager/company-mortgage-manager.component';
import { CreditInstituteManagerComponent } from './component/credit-institute-manager/credit-institute-manager.component';
import { AddAmortizationComponent } from './component/add-amortization/add-amortization.component';

@NgModule({
  imports: [CommonModule, CoreModule, MortgageRoutingModule],
  declarations: [
    CompanyMortgageFormComponent,
    CompanyMortgageManagerComponent,
    CreditInstituteFormComponent,
    CreditInstituteManagerComponent,
    AddAmortizationComponent,
  ],
  providers: [CompanyMortgageService, CreditInstituteService, MortgageGuard],
  exports: [],
})
export class MortgageModule {}
